<template>
  <div class="components__cnt-table_milestones">
    <p></p>
    <table>
      <thead>
        <tr>
          <td>
            <p>
              <strong>Checkliste Aufgaben:</strong>
            </p>
            <p></p>
          </td>
          <td>
            <p>
              <strong>Erledigt</strong>
              <br />(Datum)
            </p>
          </td>
        </tr>
      </thead>
      <thead>
        <tr>
          <td colspan="2">
            <p>
              <strong>Im Vorfeld der Einstellung:</strong>
            </p>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <p>Gemeinsame Ausarbeitung des Weiterbildungs-Vertrages</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Approbation, Impfpass, ggf. Serologie</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Ausfüllen und Einreichen des Antrags auf Genehmigung zur Anstellung einer/-es ÄiW</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Ausfüllen und Einreichen des Antrags auf Förderung der Weiterbildung zum Pädiater</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Allen Ärzt*innen der Praxis vorgestellt (mindestens 1 Kaffee miteinander)</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Einführung in Standards zu Hygiene und Arbeitssicherheit</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Einführung in Standards zu Datenschutz und Schweigepflicht</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Bekleidungskodex, Patienteninformation, Außendarstellung (ÄiW/Patienten)</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>PaedCompenda erklärt</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Planung von wöchentlichen Beobachtungs- und Rückmeldezeiten sowie Zeiten für die Bearbeitung der Lernzielbögen</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Möglichkeit der Hospitation bei verschiedenen Vorstellungsanlässen angeboten</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Über QZ-Arbeit informiert und Mitarbeit angeboten</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>&hellip;</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
      </tbody>
      <thead>
        <tr>
          <td colspan="2">
            <p>
              <strong>1.Tag</strong> (bis 1. Woche, nach Stellenumfang und Vorerfahrung):
            </p>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <p>Med. Fachangestellten (MFA) vorgestellt (mindestens 1 Kaffee miteinander)</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Praxisorganisation und häufige Abläufe besprochen (Grundlage: Praxis-QM)</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Ein Schild bzw. Aushang sollte die AiW kurz vorstellen</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Einweisung in Praxis-EDV (Grundlagen) durchgeführt</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Praxisinterne Routine-Dokumentation vereinbart</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Arzt-Patienten-Kontakte beobachtet</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>ÄiW wird Patienten vorgestellt mit dem Hinweis, dass sie/er jetzt zum ärztlichen Team dazugehört und Betreuung übernehmen kann.</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Rücksprache-Regeln vereinbart</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              Tatbestände vereinbart, bei denen
              <u>grundsätzlich</u> eine Rücksprache erfolgen soll (z.B. „vor Überweisung“ oder „Krankenhaus-Einweisung“) oder direkt möglich gemacht werden muss (akutes Problem/Notfall)
            </p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Einführung im Umgang mit Notfällen erfolgt</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>&hellip;</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
      </tbody>
      <thead>
        <tr>
          <td colspan="2">
            <p>
              <strong>1. Woche</strong> (bis 1. Monat, nach Stellenumfang und Vorerfahrung):
            </p>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <p>Hospitationen der/des ÄiW und Rückmeldung von und an die Weiterbilder</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>ÄiW behandelt Patienten unter Supervision und erhält Rückmeldung von den Weiterbildern</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Wichtige Formulare besprochen: Kleine Formularkunde, wie für APT 1 erforderlich</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Vorgehen für Fallbesprechung vereinbart</p>
            <p>
              <em>Hier stellt die ÄiW ihre schwierigen oder unklaren Fälle vor (soweit nicht schon direkte Rücksprache erfolgt), der Weiterbilder sucht aus eigener Initiative instruktive Fälle zur Besprechung heraus und drittens können hier allgemeine Themen (s.u.) besprochen werden</em>
            </p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Erste Lernzielbögen bearbeitet und besprochen: Schwerpunkte der Weiterbildung definiert (Learning Contract)</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Grundsätze der Verschreibung von Medikamenten besprochen</p>
            <p>
              <em>Wirtschaftlichkeit, Generika, Probleme von Analogpräparaten, Individualliste (d.h. eine definierte Liste von Medikamenten, welche die Weiterbilder bzw. die Praxis regelmäßig verschreibt – idealer Weise im Praxis-PC gespeichert)</em>
            </p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Einweisung in Akutlabor der Praxis erfolgt – Einsatzmöglichkeiten, Indikationen und Resourcen</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Einführungsstrategie für ÄiW vereinbart</p>
            <p>
              <em>Schon aus eigenem Interesse (Entlastung!) sollten die Weiterbilder dafür sorgen, dass die Patienten der Praxis die ÄiW als kompetente und vertrauenswürdige Ärztin akzeptieren. Wenn im Gespräch mit dem Weiterbilder ein Patient auf die ÄiW Bezug nimmt, reagiert dieser positiv (auch Mimik und Körpersprache bedenken). Meinungsunterschiede werden ausschließlich unter vier Augen besprochen!</em>
            </p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Vorgehen bei häufigen Problemen (Anfänger-Niveau nach Weiterbildungsstand): Beratungsanlässe bzw. Probleme aus den „Kernkompetenzen“ APT 1</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Mindestens ein Fehler nachbesprochen</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>ÄiW erhält die Möglichkeit an relevanten Teambesprechungen teilzunehmen</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>&hellip;</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
      </tbody>
      <thead>
        <tr>
          <td colspan="2">
            <p>
              <strong>1. Monat</strong> (bis 1. Quartal, nach Stellenumfang und Vorerfahrung):
            </p>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <p>Wichtige Formulare besprochen: Große Formularkunde</p>
            <p>(Überweisung, Einweisung, AU, BG-Formular, Heilmittelrezepte, Impfstoffrezepte, Heilmittelrezepte, …</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Grundsätze der Verschreibung von Heil- und Hilfsmitteln besprochen</p>
            <p>Wirtschaftlichkeit, häufige Indikationen und Verschreibungen</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Einweisung in spezifische Diagnostik der Praxis erfolgt</p>
            <p>
              <em>(EKG, Spirometrie usw. soweit vorhanden; Indikation, Durchführung und Interpretation von Ergebnissen)</em>
            </p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Überweisungs- und Einweisungs-Ziele besprochen</p>
            <p>Aufstellung häufiger Überweisungs-Anlässe und geeigneter Facharzt-Praxen der Umgebung (z.B. Neuropädiatrie, Kinderkardiologie, -gastroenterologie, -dermatologie, -radiologie, KJP, HNO; geeignete Krankenhäuser bzw. –abteilungen</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Vorgehen Prävention erläutert („Kernkompetenzen“APT 5)</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Weitere Lernzielbögen bearbeitet und besprochen</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Beobachten, rückmelden und (soweit möglich) anvertrauen APT1</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>&hellip;</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
      </tbody>
      <thead>
        <tr>
          <td colspan="2">
            <p>
              <strong>1. Quartal</strong> (oder folgende Quartale, nach Stellenumfang und Vorerfahrung):
            </p>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <p>Vorgehen bei komplexen Problemen erläutert („Kernkompetenzen“ APT 2, 3 und 4)</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Fortbildungs-Strategie besprochen</p>
            <p>
              <em>(Zeitschriften, Veranstaltungen, Information über Medikamente, Nachschlage-Möglichkeiten (Lehrbücher, Internet-Zugang), Leitlinien,…)</em>
            </p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Besuch der regionalen Fortbildungsveranstaltungen</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Weiterbildungsgespräche durchgeführt</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>An einer Notfallübung in der Praxis teilgenommen</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Beobachten, rückmelden und (soweit möglich) anvertrauen APT 5 (und evtl. weitere)</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Weitere Lernzielbögen bearbeitet und besprochen</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>&hellip;</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
      </tbody>
      <thead>
        <tr>
          <td colspan="2">
            <p>
              <strong>Folgende Quartale</strong> (gesamte Weiterbildung, nach Stellenumfang und Vorerfahrung):
            </p>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <p>Vorgehen bei weiteren Problemen erläutert („Kernkompetenzen“ APT 3,4, 5, 7, 9, 10 und 11)</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Vorgehen bei sozialpädiatrischen Problemen erläutert („Kernkompetenzen“ APT 6)</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Mindestens eine sozialpädiatrische Stellungnahme verfasst (ambulante oder stationäre Rehabilitationskur, Mutter-Kind-Kur, Vorsorgekur, Eingliederungshilfe, Versorgungsamtsanfrage)</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Weitere Lernzielbögen bearbeitet und besprochen</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Beobachten, rückmelden und anvertrauen weiterer APTS</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>ÄiW hat „eigene“ Patienten</p>
            <p>
              <em>(Das sind Patienten, welche die ÄiW als vertrauenswürdige Anlaufstelle in der Praxis angenommen haben. Durch Fallbesprechungen und Rücksprachen bleibt die Kontinuität der Betreuung durch den Weiterbilder erhalten. Manchen Weiterbildern ist lieber, wenn diese Patienten abwechselnd bei ihnen in die Sprechstunden kommen. Überlegen Sie genau, ob das medizinische nötig ist, oder Sie vielleicht doch eher Schwierigkeiten haben „loszulassen“)</em>
            </p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Besonderheiten der sektorenübergreifenden Behandlung besprochen</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Netzwerk mit Jugendhilfe und pädagogischem System am konkreten Fall erarbeitet („Kernkompetenzen“ APT 8)</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>An einem Qualitätszirkel teilgenommen, auf Balintgruppe hinweisen</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Kontakt zu anderen Ärzten in der Region/im Ort/ Stadtteil aufgenommen</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Beteiligung am Qualitätsmanagement der Praxis („Kernkompetenzen“ APT 12)</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Beteiligung der ÄiW an mindestens 1 Quartalsabrechnung anbieten (Grundzüge EBM und GOÄ)</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>ÄiW bei mindestens 1 Problem der Personalführung einbezogen</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>Prüfungsvorbereitung</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
        <tr>
          <td>
            <p>&hellip;</p>
          </td>
          <td>
            <p></p>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td class="table-caption" colspan="2">
            <b>Tab. 1</b>
            Tabelle der Meilensteine (Stand Oktober 2019,
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.dgaap.de/fileadmin/Bilderdatenbank/PDF/DGAAP_Lernort_Praxis_319.pdf"
            >als PDF zum Download</a>)
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<style lang="scss" scoped>
.components__cnt-table_milestones {
  @import "~stylesheets/frontend/specific/content-widgets_tables";
  table {
    max-width: 750px;
  }
}
</style>
